import {combineReducers} from 'redux'
import {reducer} from 'redux-form'
import appReducer from './containers/App/reducer'
import userReducer from './models/user/reducer'

export default function createReducer(injectedReducers) {
  return combineReducers({
    form: reducer,
    app: appReducer,
    user: userReducer,
    ...injectedReducers
  })
}
